/**
 * Finishing - YouTube
 *
 * JS pour la gestion de YouTube
 *
 * @since       05.10.2015
 * @version     1.0.0.1
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery(document).ready(function() {
    
    /***********************************/
    /********** CANAL YOUTUBE **********/
    /***********************************/
    
    if ( jQuery( '.youtube-channel-videos-container' ).length > 0 ) {
        
        /**********/
        /********** PAGE SUIVANTE/PRÉCÉDENTE **********/
        /**********/
        
        jQuery( document ).on( 'click', '.youtube-channel-videos-prev, .youtube-channel-videos-next', function( event ) {
            
            event.preventDefault();
            
            var token = jQuery( this ).attr( 'data-token' );
            var channel = jQuery( this ).attr( 'data-channel' );
            var results = jQuery( this ).attr( 'data-results' );

            jQuery.ajax({
                type : "POST",
                async: false,
                url : data_sage_js.ajaxurl,
                dataType: 'json',
                data: {
                    action: 'loadYouTubeVidsAjax',
                    token: token,
                    channelId: channel,
                    resultsPerPage: results
                },
                success: function( data ) {

                    if ( data.answer === 1 ) {

                        jQuery( '.youtube-channel-videos-container' ).empty();
                        jQuery( '.youtube-channel-videos-container' ).html( data.content );
                        
                    } else {

                        jQuery( '.youtube-channel-videos-container' ).html( '<p>Une erreur s\'est produite ! - 1</p>' );
                        
                    //END else
                    }

                //END success
                },
                error: function () {

                    jQuery( '.youtube-channel-videos-container' ).html( '<p>Une erreur s\'est produite ! - 2</p>' );

                }

            //END ajax
            });
            
            return false;

        //END jQuery( document ).on( 'click', '.youtube-channel-videos-prev, .youtube-channel-videos-next', function( event )
        });
     
    //END if ( jQuery( '.youtube-channel-videos-container' ).length > 0 )
    }

//END jQuery(document).ready
});
